module.exports = __webpack_public_path__ + "media/Doce.e4ca9d41.mp3";